import * as React from 'react'
import { InstructionsCard } from 'snippet/instructionsCard'
import codeIcon from './snippetContainer/code.svg'
import { Account } from 'auth/state'
import { CopySnippetElement, RelativeButton } from 'snippet/copySnippetElement'
import { t } from 'translations'

interface AddMyselfCardProps {
    account: Account
    detectSnippet: () => void
}

interface AddMyselfCardState {
    copied: boolean
}

export class AddMyselfCard extends React.Component<AddMyselfCardProps, AddMyselfCardState> {
    onCopy = () => {
        this.setState({ copied: true })
        setTimeout(() => this.setState({ copied: false }), 2000)
    }

    render() {
        const { account, detectSnippet } = this.props
        const closedSubHeader = t('snippet.addMyself.closedSubHeader')
        const openedSubHeader = t('snippet.addMyself.openedSubHeader')

        return (
            <InstructionsCard
                iconSrc={codeIcon}
                header={t('snippet.addMyself.header')}
                closedSubHeader={closedSubHeader}
                openedSubHeader={openedSubHeader}
            >
                <CopySnippetElement account={account}>
                    <RelativeButton className="visible" onClick={detectSnippet} size="large">
                        {t('snippet.addMyself.checkNow')}
                    </RelativeButton>
                </CopySnippetElement>
            </InstructionsCard>
        )
    }
}
